import React from "react";
import { DisplayWithIcon } from "../shared/Typography/types";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  TestResultIconAndTypography,
  TestResultsIcon,
} from "./TestResults.styles";

export const TestResultsAneuploidyRisk = (
  displayWithIcon: DisplayWithIcon,
  label = "Aneuploidy Screen",
): React.ReactElement => {
  const isSeeReport =
    (displayWithIcon.rawDisplay || displayWithIcon.display) === "See Report";

  return (
    <>
      {GetTypographyContent({
        content: label,
        size: "large",
        textColor: "greyMedium",
        isBold: true,
        isCaps: true,
      })}

      <TestResultIconAndTypography>
        <TestResultsIcon marginLeft={isSeeReport}>
          {displayWithIcon.icon}
        </TestResultsIcon>
        {GetTypographyContent({
          content: displayWithIcon.display,
          size: "medium",
          textColor: isSeeReport ? "redDark" : "greyMedium",
        })}
      </TestResultIconAndTypography>
    </>
  );
};
